module.exports = __webpack_public_path__ + "static/media/mouthLowerDownLeft.0ee835bd.obj";